import { HighlightStyle, syntaxHighlighting } from "@codemirror/language";
import { tags as t } from "@lezer/highlight";
import { customTags } from "./markdown-extensions";

/**
 * Token colors for markdown constructs and fenced code, all via CSS vars.
 * Sizing/layout of headings etc. is handled by line decorations in
 * live-preview.ts; this handles color/weight/style of inline tokens.
 */
const hydraHighlight = HighlightStyle.define(
  [
    // markdown structure
    { tag: t.heading, color: "var(--md-heading)" },
    { tag: t.processingInstruction, color: "var(--md-syntax)" }, // #, >, - marks
    { tag: t.emphasis, fontStyle: "italic" },
    { tag: t.strong, fontWeight: "700" },
    { tag: t.strikethrough, textDecoration: "line-through", color: "var(--text-secondary)" },
    { tag: t.monospace, fontFamily: "var(--font-mono)", fontSize: "0.88em" },
    { tag: t.link, color: "var(--md-link)" },
    { tag: t.url, color: "var(--text-muted)" },
    { tag: t.quote, color: "var(--md-quote)" },
    { tag: t.contentSeparator, color: "var(--md-hr)" },
    { tag: t.escape, color: "var(--code-number)" },

    // custom inline nodes
    { tag: customTags.wikilink, color: "var(--md-wikilink)" },
    { tag: customTags.wikilinkMark, color: "var(--md-syntax)" },
    { tag: customTags.hashtag, color: "var(--md-tag)" },
    { tag: customTags.highlight, backgroundColor: "var(--md-highlight-bg)", borderRadius: "2px" },
    { tag: customTags.highlightMark, color: "var(--md-syntax)" },
    { tag: customTags.subtextMark, color: "var(--md-syntax)" },

    // fenced code
    { tag: t.keyword, color: "var(--code-keyword)" },
    { tag: [t.string, t.special(t.string)], color: "var(--code-string)" },
    { tag: [t.number, t.bool, t.null], color: "var(--code-number)" },
    { tag: [t.comment, t.blockComment, t.lineComment], color: "var(--code-comment)", fontStyle: "italic" },
    { tag: [t.function(t.variableName), t.function(t.propertyName)], color: "var(--code-function)" },
    { tag: [t.typeName, t.className, t.namespace], color: "var(--code-type)" },
    { tag: [t.propertyName, t.attributeName], color: "var(--code-property)" },
    { tag: [t.operator, t.punctuation, t.bracket], color: "var(--code-operator)" },
    { tag: [t.variableName, t.name], color: "var(--text-primary)" },
    { tag: t.labelName, color: "var(--code-property)" },
    { tag: t.meta, color: "var(--text-muted)" },
  ],
  { themeType: "dark" },
);

export const hydraSyntaxHighlighting = syntaxHighlighting(hydraHighlight);
